import React, { useEffect } from 'react';
import uniqueId from 'lodash/uniqueId';
import Utils from '../utils';
import UI from '../ui';
import SocialMediaInput from './SocialMediaInput.component';
import Util from './Util';

const { WrappedInputTextWithLabel, WrappedInputTextareaWithLabel } = UI;
const socialMediaTypes = ['Facebook', 'Twitter', 'Instagram', 'Youtube', 'Pinterest', 'Linkedin'];
const { Validation } = Utils;

const LinksTabPanel = props => {
	const {
		setBrandedTrackingConfig,
		email,
		phone,
		returnPolicy,
		menuLinks,
		socialMedia,
		isValidationNeeded,
	} = props;

	useEffect(() => {
		// menu has to have predefined number of links, so init state with this number of items
		const menuLinksCount = 4;
		const emptyMenuLinks = Array(menuLinksCount - menuLinks.length).fill({
			Text: '',
			Url: '',
			Key: uniqueId(),
		});

		setBrandedTrackingConfig({
			MenuLinks: [...menuLinks, ...emptyMenuLinks],
			SocialMedia: socialMediaTypes.map(
				type => socialMedia.find(({ Type }) => Type === type) || { Type: type, Url: '' }
			),
		});
	}, []);

	const onFieldChange = event => {
		let { value, name } = event.target;

		if (name === 'Phone') {
			value = Utils.Util.formatPhoneNumber(value);
		}

		setBrandedTrackingConfig({ [name]: value });
	};

	const onSocialMediaFieldChange = event => {
		const { value, name } = event.target;
		const newSocialMedia = socialMedia.map(media =>
			media.Type === name ? { ...media, Url: value } : media
		);

		setBrandedTrackingConfig({ SocialMedia: newSocialMedia });
	};

	const onMenuLinkFieldChange = event => {
		const { value, name } = event.target;
		const [fieldName, fieldIndex] = name.split('-');

		setBrandedTrackingConfig({
			MenuLinks: menuLinks.map((menu, index) =>
				fieldIndex === `${index}`
					? {
							...menu,
							[fieldName]: value,
					  }
					: menu
			),
		});
	};

	return (
		<div className="branded-tracking-links-tab-panel">
			<section>
				<h2>
					Menu Links <span>(Optional):</span>
				</h2>
				<div className="p-grid p-nogutter">
					{menuLinks.map((menuLink, index) => (
						<React.Fragment key={menuLink.key || `menu-link-${index}`}>
							<WrappedInputTextWithLabel
								className="p-col-5 links-tab-input-wrapper"
								label={`Menu Item ${index + 1}`}
								isInputInvalid={
									isValidationNeeded && Util.isMenuTextInvalid(menuLink)
								}
								errorMessage="Menu Item Name is required"
								showErrorBelow
								uiElementConfig={{
									value: menuLink.Text || '',
									onChange: onMenuLinkFieldChange,
									maxLength: 100,
									dataqa: `Text-${index}`,
									name: `Text-${index}`,
								}}
							/>
							<WrappedInputTextWithLabel
								className="p-col-7 right-col links-tab-input-wrapper"
								label={`Link ${index + 1}`}
								isInputInvalid={
									isValidationNeeded && Util.isMenuUrlInvalid(menuLink)
								}
								errorMessage={Util.getUrlValidationError(menuLink.Url)}
								showErrorBelow
								uiElementConfig={{
									value: menuLink.Url || '',
									onChange: onMenuLinkFieldChange,
									maxLength: 100,
									dataqa: `Url-${index}`,
									name: `Url-${index}`,
								}}
							/>
						</React.Fragment>
					))}
				</div>
			</section>
			<section>
				<h2>
					Social Links <span>(Optional):</span>
				</h2>
				<div className="p-grid p-nogutter">
					{socialMedia.map((media, index) => (
						<SocialMediaInput
							className={`links-tab-input-wrapper ${
								index % 2 === 1 ? 'p-col-7 right-col' : 'p-col-5'
							}`}
							key={media.Type}
							{...media}
							onChange={onSocialMediaFieldChange}
						/>
					))}
				</div>
			</section>
			<section className="contact-section">
				<h2>
					Contact Information <span>(Optional):</span>
				</h2>
				<WrappedInputTextWithLabel
					className="contact-input-wrapper"
					label="Email:"
					isInputInvalid={
						isValidationNeeded && !(email ? Validation.isValidEmail(email) : true)
					}
					errorMessage="Please enter a valid email address"
					showErrorBelow
					uiElementConfig={{
						value: email || '',
						onChange: onFieldChange,
						maxLength: 255,
						dataqa: 'Email',
						name: 'Email',
					}}
				/>
				<WrappedInputTextWithLabel
					className="contact-input-wrapper"
					label="Phone Number:"
					isInputInvalid={
						isValidationNeeded && !!phone && !Validation.isValidPhone(phone)
					}
					errorMessage="Please enter a valid phone number"
					showErrorBelow
					uiElementConfig={{
						value: phone || '',
						onChange: onFieldChange,
						maxLength: 23,
						dataqa: 'Phone',
						name: 'Phone',
					}}
				/>
				<WrappedInputTextareaWithLabel
					className="return-policy-input-wrapper"
					label="Return Policy:"
					uiElementConfig={{
						value: returnPolicy || '',
						placeholder: 'Maximum length: 500 characters',
						onChange: onFieldChange,
						rows: 5,
						cols: 31,
						maxLength: 500,
						dataqa: 'ReturnPolicy',
						name: 'ReturnPolicy',
					}}
				/>
			</section>
		</div>
	);
};

export default LinksTabPanel;
